import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import VenueSignature from './VenueSignature';

const Footer = ({ socialLinks }) => {
  return (
    <footer className="px-6 py-16 bg-black border-t border-white/10">
      <div className="mx-auto max-w-5xl">
        <div className="flex flex-col gap-8 justify-between items-center md:flex-row md:items-start">
          {/* Logo */}
          <div className="flex flex-col gap-4 items-center md:flex-row md:gap-5 md:items-center">
            <div className="text-3xl font-black tracking-tighter">
              <span className="block leading-none text-center">CRA</span>
              <span className="block leading-none text-center">PULE</span>
            </div>
            <VenueSignature
              className="gap-3 px-3 py-2 opacity-90"
              labelClassName="text-[9px] tracking-[0.24em]"
              logoClassName="w-28 h-8 sm:w-32 sm:h-9"
            />
          </div>

          {/* Social Links */}
          <div className="flex gap-3 items-center">
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex justify-center items-center w-11 h-11 text-gray-400 transition-colors hover:text-white"
            >
              <Instagram size={24} />
            </a>
            <a
              href={`mailto:${socialLinks?.email || 'contact@crapule.xyz'}`}
              aria-label="Email"
              className="inline-flex justify-center items-center w-11 h-11 text-gray-400 rounded-full hover:text-white"
            >
              <Mail size={24} />
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2 justify-between items-center pt-8 mt-12 text-sm text-gray-500 border-t border-white/10 md:flex-row">
          <p>© 2026 Crapule. Tous droits réservés.</p>
          <p>Un soir où la cuisine rencontre le son.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
